<script lang="ts" setup>
    const {
        loading = false,
        arrow = false,
        href,
    } = defineProps<{
        loading?: boolean
        arrow?: boolean
        href?: string
    }>()
</script>

<template>
    <NuxtLink v-if="href" :to="href" class="pretty-button hover:bg-white"><slot /></NuxtLink>

    <button
        v-else
        class="pretty-button"
        :class="{ 'hover:bg-white': !loading, 'cursor-not-allowed': loading }"
    >
        <span :class="{ 'opacity-0': loading }">
            <slot />
        </span>

        <span
            class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
            :class="{ invisible: !loading, 'opacity-0': !loading }"
        >
            <svg
                class="h-5 w-5 animate-spin"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
            >
                <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                ></circle>
                <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
            </svg>
        </span>
    </button>
</template>

<style scoped>
    .pretty-button {
        @apply relative border px-3 py-1 uppercase transition xl:px-4 xl:py-2;
    }
</style>
